var _path, _path2, _mask, _path3, _path4, _rect, _path5, _path6, _mask2, _path7, _path8, _rect2, _path9, _path10, _rect3, _rect4, _rect5, _line, _line2, _path11, _path12, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _path13, _line3, _path14, _rect12, _path15, _path16, _rect13, _rect14, _rect15;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTram4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 666,
    height: 241,
    viewBox: "0 0 666 241",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M635.781 42.4969C660.4 62.0317 660.4 120.113 660.4 120.113V125.622H416.669V110.617H175.4V105.108C175.4 105.108 175.4 77.0271 200.02 57.4922C224.639 37.9573 261.568 25.6172 419.131 25.6172V25.6216C436.507 25.6186 452.398 25.5843 466.955 25.5529C582.663 25.3033 614.027 25.2357 635.781 42.4969Z",
    fill: "#9AFF6B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M635.781 42.4969L632.673 46.4136L632.673 46.4136L635.781 42.4969ZM660.4 125.622V130.622H665.4V125.622H660.4ZM416.669 125.622H411.669V130.622H416.669V125.622ZM416.669 110.617H421.669V105.617H416.669V110.617ZM175.4 110.617H170.4V115.617H175.4V110.617ZM200.02 57.4922L203.128 61.409L203.128 61.409L200.02 57.4922ZM419.131 25.6172H424.131V20.6172L419.131 20.6172L419.131 25.6172ZM419.131 25.6216H414.131V30.6225L419.132 30.6216L419.131 25.6216ZM466.955 25.5529L466.944 20.553L466.955 25.5529ZM660.4 120.113C665.4 120.113 665.4 120.111 665.4 120.11C665.4 120.109 665.4 120.107 665.4 120.106C665.4 120.103 665.4 120.099 665.4 120.094C665.4 120.084 665.4 120.07 665.4 120.054C665.4 120.02 665.4 119.972 665.4 119.911C665.399 119.789 665.397 119.613 665.394 119.386C665.388 118.931 665.375 118.272 665.35 117.431C665.3 115.75 665.202 113.343 665.005 110.398C664.611 104.519 663.824 96.4532 662.243 87.7377C660.665 79.0424 658.273 69.5647 654.62 60.9192C650.984 52.3165 645.951 44.1837 638.889 38.5801L632.673 46.4136C637.921 50.5775 642.12 57.0303 645.409 64.812C648.679 72.5508 650.903 81.2561 652.403 89.5229C653.899 97.7695 654.651 105.445 655.027 111.066C655.215 113.872 655.308 116.154 655.354 117.727C655.378 118.512 655.389 119.12 655.395 119.525C655.398 119.728 655.399 119.88 655.4 119.979C655.4 120.029 655.4 120.065 655.4 120.087C655.4 120.098 655.4 120.106 655.4 120.11C655.4 120.112 655.4 120.114 655.4 120.114C655.4 120.114 655.4 120.114 655.4 120.114C655.4 120.113 655.4 120.113 660.4 120.113ZM665.4 125.622V120.113H655.4V125.622H665.4ZM416.669 130.622H660.4V120.622H416.669V130.622ZM411.669 110.617V125.622H421.669V110.617H411.669ZM416.669 105.617H175.4V115.617H416.669V105.617ZM180.4 110.617V105.108H170.4V110.617H180.4ZM175.4 105.108C180.4 105.108 180.4 105.11 180.4 105.112C180.4 105.112 180.4 105.114 180.4 105.115C180.4 105.117 180.4 105.119 180.4 105.12C180.4 105.122 180.4 105.123 180.4 105.122C180.4 105.12 180.4 105.112 180.401 105.097C180.401 105.067 180.402 105.011 180.404 104.931C180.409 104.77 180.419 104.51 180.44 104.161C180.481 103.462 180.567 102.407 180.743 101.064C181.095 98.3753 181.805 94.5618 183.233 90.1721C186.087 81.3966 191.77 70.4211 203.128 61.409L196.912 53.5754C183.65 64.0981 177.024 76.9305 173.723 87.0792C172.073 92.1515 171.245 96.5792 170.827 99.7659C170.618 101.361 170.512 102.652 170.457 103.565C170.43 104.022 170.416 104.385 170.408 104.645C170.405 104.775 170.403 104.879 170.402 104.957C170.401 104.996 170.401 105.028 170.401 105.053C170.401 105.065 170.4 105.076 170.4 105.086C170.4 105.09 170.4 105.094 170.4 105.098C170.4 105.1 170.4 105.102 170.4 105.103C170.4 105.106 170.4 105.108 175.4 105.108ZM203.128 61.409C226.172 43.1239 261.268 30.6172 419.131 30.6172L419.131 20.6172C261.868 20.6172 223.106 32.7907 196.912 53.5754L203.128 61.409ZM414.131 25.6172V25.6216H424.131V25.6172H414.131ZM466.944 20.553C452.387 20.5844 436.5 20.6186 419.13 20.6216L419.132 30.6216C436.513 30.6186 452.41 30.5843 466.966 30.5529L466.944 20.553ZM638.889 38.5801C626.874 29.0462 612.422 24.6174 587.021 22.476C561.725 20.3436 524.68 20.4284 466.944 20.553L466.966 30.5529C524.938 30.4279 561.429 30.3541 586.181 32.4407C610.827 34.5184 622.935 38.6863 632.673 46.4136L638.889 38.5801Z",
    fill: "black"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_1170_10510",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155 110.5V215.496C155 229.303 166.193 240.496 180 240.496H640C653.807 240.496 665 229.303 665 215.496V110.5H155Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155 110.5V215.496C155 229.303 166.193 240.496 180 240.496H640C653.807 240.496 665 229.303 665 215.496V110.5H155Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M155 110.5V100.5H145V110.5H155ZM665 110.5H675V100.5H665V110.5ZM165 215.496V110.5H145V215.496H165ZM180 230.496C171.716 230.496 165 223.78 165 215.496H145C145 234.826 160.67 250.496 180 250.496V230.496ZM640 230.496H180V250.496H640V230.496ZM655 215.496C655 223.78 648.284 230.496 640 230.496V250.496C659.33 250.496 675 234.826 675 215.496H655ZM655 110.5V215.496H675V110.5H655ZM665 100.5H155V120.5H665V100.5Z",
    fill: "black",
    mask: "url(#path-3-inside-1_1170_10510)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 92.5,
    y: 43,
    width: 55,
    height: 170,
    rx: 7.5,
    fill: "#9AFF6B",
    stroke: "black",
    strokeWidth: 5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.7475 57.375C15 76.9099 15 104.991 15 104.991V110.5H257.021V125.622H500.752V120.113C500.752 120.113 500.752 62.0317 476.133 42.4969C454.379 25.2357 423.014 25.3033 307.307 25.5529C292.894 25.584 277.174 25.6179 260 25.6215V25.5C101.616 25.5 64.4949 37.8401 39.7475 57.375Z",
    fill: "#9AFF6B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7475 57.375L36.6495 53.4504L36.6495 53.4504L39.7475 57.375ZM15 110.5H10V115.5H15V110.5ZM257.021 110.5H262.021V105.5H257.021V110.5ZM257.021 125.622H252.021V130.622H257.021V125.622ZM500.752 125.622V130.622H505.752V125.622H500.752ZM476.133 42.4969L473.025 46.4136L473.025 46.4136L476.133 42.4969ZM307.307 25.5529L307.296 20.553L307.307 25.5529ZM260 25.6215H255V30.6226L260.001 30.6215L260 25.6215ZM260 25.5H265V20.5L260 20.5L260 25.5ZM15 104.991C20 104.991 20 104.993 20 104.995C20 104.995 20 104.997 20 104.998C20 105 20 105.002 20 105.003C20 105.005 20 105.006 20 105.005C20 105.003 20.0001 104.995 20.0003 104.98C20.0007 104.95 20.0017 104.894 20.004 104.814C20.0086 104.653 20.0184 104.394 20.0394 104.045C20.0812 103.347 20.1673 102.292 20.3439 100.95C20.6977 98.2627 21.4112 94.4506 22.8459 90.0622C25.7136 81.2904 31.4252 70.3144 42.8454 61.2996L36.6495 53.4504C23.3223 63.9705 16.6601 76.8023 13.341 86.9547C11.6822 92.0284 10.849 96.4574 10.4294 99.6454C10.2194 101.241 10.1121 102.533 10.0573 103.447C10.0299 103.904 10.0156 104.267 10.0081 104.527C10.0044 104.657 10.0023 104.762 10.0012 104.839C10.0007 104.878 10.0004 104.91 10.0002 104.936C10.0001 104.948 10.0001 104.959 10 104.968C10 104.973 10 104.977 10 104.981C10 104.983 10 104.985 10 104.986C10 104.988 10 104.991 15 104.991ZM20 110.5V104.991H10V110.5H20ZM257.021 105.5H15V115.5H257.021V105.5ZM252.021 110.5V125.622H262.021V110.5H252.021ZM257.021 130.622H500.752V120.622H257.021V130.622ZM505.752 125.622V120.113H495.752V125.622H505.752ZM500.752 120.113C505.752 120.113 505.752 120.111 505.752 120.11C505.752 120.109 505.752 120.107 505.752 120.106C505.752 120.103 505.752 120.099 505.752 120.094C505.752 120.084 505.752 120.07 505.752 120.054C505.752 120.02 505.752 119.972 505.751 119.911C505.75 119.789 505.749 119.613 505.745 119.386C505.739 118.931 505.727 118.272 505.702 117.431C505.652 115.75 505.553 113.343 505.356 110.398C504.963 104.519 504.175 96.4532 502.594 87.7377C501.017 79.0424 498.625 69.5647 494.971 60.9192C491.336 52.3165 486.303 44.1837 479.241 38.5801L473.025 46.4136C478.272 50.5775 482.471 57.0303 485.76 64.812C489.031 72.5508 491.255 81.2561 492.755 89.5229C494.251 97.7695 495.002 105.445 495.378 111.066C495.566 113.872 495.66 116.154 495.706 117.727C495.729 118.512 495.741 119.12 495.746 119.525C495.749 119.728 495.751 119.88 495.751 119.979C495.752 120.029 495.752 120.065 495.752 120.087C495.752 120.098 495.752 120.106 495.752 120.11C495.752 120.112 495.752 120.114 495.752 120.114C495.752 120.114 495.752 120.114 495.752 120.114C495.752 120.113 495.752 120.113 500.752 120.113ZM479.241 38.5801C467.225 29.0462 452.774 24.6174 427.372 22.476C402.077 20.3436 365.032 20.4284 307.296 20.553L307.317 30.5529C365.289 30.4279 401.78 30.3541 426.532 32.4407C451.178 34.5184 463.286 38.6863 473.025 46.4136L479.241 38.5801ZM307.296 20.553C292.883 20.584 277.167 20.6179 259.999 20.6215L260.001 30.6215C277.18 30.6179 292.906 30.584 307.317 30.5529L307.296 20.553ZM255 25.5V25.6215H265V25.5H255ZM42.8454 61.2996C66.0203 43.0061 101.316 30.5 260 30.5L260 20.5C101.917 20.5 62.9696 32.6742 36.6495 53.4504L42.8454 61.2996Z",
    fill: "black"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-8-inside-2_1170_10510",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 105.5V215.498C0 229.305 11.1929 240.498 25 240.498H480C493.807 240.498 505 229.305 505 215.498V105.5H0Z"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 105.5V215.498C0 229.305 11.1929 240.498 25 240.498H480C493.807 240.498 505 229.305 505 215.498V105.5H0Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0 105.5V95.5H-10V105.5H0ZM505 105.5H515V95.5H505V105.5ZM10 215.498V105.5H-10V215.498H10ZM25 230.498C16.7157 230.498 10 223.782 10 215.498H-10C-10 234.828 5.67002 250.498 25 250.498V230.498ZM480 230.498H25V250.498H480V230.498ZM495 215.498C495 223.782 488.284 230.498 480 230.498V250.498C499.33 250.498 515 234.828 515 215.498H495ZM495 105.5V215.498H515V105.5H495ZM505 95.5H0V115.5H505V95.5Z",
    fill: "#9AFF6B",
    mask: "url(#path-8-inside-2_1170_10510)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 500,
    y: 110.5,
    width: 155,
    height: 10,
    fill: "#9AFF6B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 205.5C20 199.977 24.4772 195.5 30 195.5H45H80H90H248.477H344.13H474.998C480.521 195.5 484.998 199.977 484.998 205.5V210.5C484.998 216.023 480.521 220.5 474.998 220.5H344.13H248.477H90H80H45H30C24.4772 220.5 20 216.023 20 210.5V205.5Z",
    fill: "#9AFF6B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M515 205.5C515 199.977 519.477 195.5 525 195.5H540H575H595H615H645C650.523 195.5 655 199.977 655 205.5V210.5C655 216.023 650.523 220.5 645 220.5H615H595H575H540H525C519.477 220.5 515 216.023 515 210.5V205.5Z",
    fill: "#9AFF6B"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 100.5,
    width: 465,
    height: 30,
    fill: "#9AFF6B"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 105.5,
    width: 490,
    height: 25,
    fill: "#9AFF6B"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 505,
    y: 120.5,
    width: 150,
    height: 10,
    fill: "#9AFF6B"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 100.5,
    x2: 15,
    y2: 115.5,
    stroke: "black",
    strokeWidth: 10
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 500,
    y1: 105.5,
    x2: 500,
    y2: 130.5,
    stroke: "black",
    strokeWidth: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M445 75.3362C445 71.9884 445.304 68.9576 446.734 66.7627C448.008 64.8075 450.545 63 456.38 63L456.785 63L456.854 63L456.857 63H456.863L456.864 63L456.864 63L456.865 63C456.865 63 456.865 63 456.865 63L460.503 63C466.401 63 471.253 68.233 474.885 75.8132C478.416 83.1819 480.214 91.6258 480.51 95.6817C480.815 99.8776 480.279 102.685 478.51 104.543C476.702 106.441 472.987 108 465.23 108H456.38C450.211 108 447.572 105.663 446.339 103.74C445.674 102.703 445.333 101.65 445.162 100.848C445.077 100.451 445.036 100.128 445.017 99.9172C445.007 99.8122 445.003 99.7365 445.001 99.6951C445 99.6803 445 99.67 445 99.6643V75.3362Z",
    stroke: "black",
    strokeWidth: 5
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M87.5 75.3362C87.5 71.9884 87.1965 68.9576 85.7659 66.7626C84.4915 64.8075 81.9546 63 76.1205 63C70.5506 63 63.3644 66.3086 56.9556 71.5829C50.5781 76.8316 45.4912 83.6027 43.7733 89.8728C41.9101 96.673 42.186 101.024 43.9858 103.644C45.7266 106.179 49.5481 108 57.27 108H76.1196C82.2895 108 84.9276 105.663 86.1607 103.74C86.8263 102.703 87.1669 101.65 87.3384 100.848C87.4233 100.451 87.464 100.128 87.4833 99.9171C87.4929 99.8122 87.4971 99.7365 87.4989 99.6951C87.4995 99.6803 87.4998 99.67 87.5 99.6643V75.3362Z",
    stroke: "black",
    strokeWidth: 5
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 157.5,
    y: 63,
    width: 45,
    height: 45,
    rx: 7.5,
    fill: "#9AFF6B",
    stroke: "black",
    strokeWidth: 5
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 63,
    width: 45,
    height: 45,
    rx: 7.5,
    fill: "#9AFF6B",
    stroke: "black",
    strokeWidth: 5
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 215,
    y: 63,
    width: 45,
    height: 45,
    rx: 7.5,
    fill: "#9AFF6B",
    stroke: "black",
    strokeWidth: 5
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 272.5,
    y: 63,
    width: 45,
    height: 45,
    rx: 7.5,
    fill: "#9AFF6B",
    stroke: "black",
    strokeWidth: 5
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 330,
    y: 63,
    width: 45,
    height: 45,
    rx: 7.5,
    fill: "#9AFF6B",
    stroke: "black",
    strokeWidth: 5
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 387.5,
    y: 63,
    width: 45,
    height: 45,
    rx: 7.5,
    fill: "#9AFF6B",
    stroke: "black",
    strokeWidth: 5
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M392.5 13V23H562.5V13L495 3L392.5 13Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 395,
    y1: 13,
    x2: 190,
    y2: 13,
    stroke: "black",
    strokeWidth: 5
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M495 3C495 3 235 3 210 3C185 3 185 25.5 185 25.5",
    stroke: "black",
    strokeWidth: 5
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 545,
    y: 125.5,
    width: 95,
    height: 60,
    fill: "#9AFF6B"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M514.977 100.133L514.977 100.13C514.968 100.017 514.954 99.8516 514.937 99.6397C514.902 99.2158 514.85 98.6058 514.784 97.8585C514.653 96.3648 514.463 94.3191 514.232 92.1139C513.777 87.7893 513.137 82.5832 512.415 79.8597C511.74 77.3125 510.658 72.8251 511.337 69.0697C511.663 67.2647 512.364 65.8288 513.542 64.8257C514.715 63.8279 516.664 63 519.999 63H559.999C565.228 63 568.284 64.6408 570.36 66.885C572.561 69.2643 573.879 72.5434 575.127 76.2904C576.303 79.8172 578.119 88.2872 578.015 95.7776C577.962 99.5466 577.423 102.763 576.309 104.951C575.768 106.014 575.132 106.753 574.423 107.23C573.734 107.694 572.845 108 571.625 108H524.999C520.627 108 518.207 106.006 516.794 104.041C516.061 103.022 515.592 101.989 515.306 101.206C515.165 100.818 515.072 100.502 515.017 100.293C515 100.229 514.987 100.175 514.977 100.133Z",
    stroke: "black",
    strokeWidth: 5
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M588.854 100.133L588.854 100.13C588.845 100.017 588.831 99.8516 588.814 99.6397C588.779 99.2158 588.727 98.6058 588.661 97.8585C588.53 96.3648 588.34 94.3191 588.108 92.1139C587.654 87.7893 587.013 82.5832 586.292 79.8597C585.617 77.3125 584.535 72.8251 585.214 69.0697C585.54 67.2647 586.241 65.8288 587.419 64.8257C588.592 63.8279 590.541 63 593.876 63H623.876C629.105 63 632.161 64.6408 634.237 66.885C636.438 69.2643 637.756 72.5434 639.004 76.2904C640.18 79.8172 641.996 88.2872 641.892 95.7776C641.839 99.5466 641.3 102.763 640.186 104.951C639.645 106.014 639.009 106.753 638.3 107.23C637.611 107.694 636.722 108 635.502 108H598.876C594.504 108 592.084 106.006 590.671 104.041C589.938 103.022 589.468 101.989 589.183 101.206C589.042 100.818 588.949 100.502 588.894 100.293C588.877 100.229 588.864 100.175 588.854 100.133Z",
    stroke: "black",
    strokeWidth: 5
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 505,
    y: 130.5,
    width: 55,
    height: 65,
    rx: 10,
    fill: "black"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 610,
    y: 130.5,
    width: 45,
    height: 65,
    rx: 10,
    fill: "black"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 570,
    y: 115.5,
    width: 30,
    height: 80,
    rx: 10,
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTram4);
export default __webpack_public_path__ + "static/media/tram4.28a528fd8d6860b137cfc85ff335e29f.svg";
export { ForwardRef as ReactComponent };